_ = require 'underscore'
Auth = require 'app/scripts/db/auth'
Controller = require 'app/scripts/controller'
localizeCount = require 'app/scripts/lib/localize-count'
{ logoDomain } = require '@trello/config'
ModelLoader = require 'app/scripts/db/model-loader'
Promise = require 'bluebird'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
l = require 'app/scripts/lib/localize'
t = require('app/scripts/views/internal/teacup-with-helpers')('board_power_ups')
{ track } = require '@trello/analytics'

module.exports = class BoardAddToTeam extends View
  initialize: ->
    me = Auth.me()
    @menuType = @options.menuType
    @listenTo me.organizationList, "add remove reset change", @frameDebounce @render
    @createNewTeam = me.organizationList.length == 0

  events: ->
    'click .js-team': 'clickTeam'
    'click .js-create-team': 'clickCreateTeam'
    'click .js-create': 'clickCreateNewTeam'
    'click .js-cancel': 'clickCancelNewTeam'

  render: ->
    @$el.html t.render =>
      if @createNewTeam
        memberCount = @model.memberList.length
        t.div '.create-team', ->
          t.p ->
            t.format 'first-create-your-business-class-team'

          t.p ->
            t.label ->
              t.format 'team-name'
              options =
                if memberCount == 1
                  { value: t.l("names-projects", { name: Auth.me().get('fullName') }, { raw: true }) }
                else if memberCount == 2
                  { placeholder: t.l("eg-names-projects", { name: Auth.me().get('fullName') }, { raw: true }) }
                else
                  {}
              options.maxLength = 100

              t.input '.full.js-autofocus.js-name', options

            if memberCount > 1
              t.div '.check-div', ->
                t.input '.js-add-members', { type: 'checkbox', checked: true, id: 'addMembers' }
                t.label { for: 'addMembers', class: 'create-team-add-members' }, ->
                  t.format 'add-the-members-of-this-board-to-the-team'

          t.div ->
            t.button '.primary.js-create', ->
              t.format 'create'

            t.a '.create-team-cancel.quiet-button.js-cancel', ->
              t.format 'cancel'

          t.hr()

        _.defer => @$('.js-name').select().focus()

      else
        orgs = Auth.me().organizationList.sortBy((org) -> org.get('displayName').toLowerCase())

        t.div '.assign-to-team', ->
          t.p ->
            t.format 'this-board-is-not-in-a-team-yet'
            t.text ' '
            t.format 'please-select-a-team-or-create-a-new-team-to-upgrade'

        if orgs.length > 0
          t.ul '.assign-to-team-list', =>
            for org in orgs
              data =
                if !org.canAddBoard(@model)
                  class: 'disabled'
                  title: t.l 'team-restrictions-prevent-you-from-adding-this-board-to-this-team'
                else if org.isAtOrOverFreeBoardLimit()
                  class: 'disabled'
                  title: l([
                    'out of free team boards',
                    'this team has reached the maximum number of open boards'
                  ])
                else
                  class: 'js-team'
                  'data-idOrganization': org.id

              t.li '.assign-to-team-list-item.js-assign-team-list-item', data, ->
                t.div '.assign-to-team-list-item-logo.js-team-logo', ->
                  logoHash = org.get('logoHash')
                  if logoHash
                    t.img { src: "#{ logoDomain }/#{ logoHash }/30.png" }
                  else
                    t.span '.icon.icon-lg.icon-organization'
                t.div '.assign-to-team-list-item-details', ->
                  t.div '.assign-to-team-list-item-name', ->
                    t.text org.get('displayName')
                    if org.isFeatureEnabled('plugins')
                      t.text ' '
                      t.icon 'business-class', class: 'icon-business-class-color'
                  t.div '.assign-to-team-list-item-member-count', ->
                    if (memberships = org.get('memberships'))?
                      t.text localizeCount('members', memberships.length)

        t.div '.assign-to-team-create.js-create-team', ->
          t.div '.assign-to-team-create-content', ->
            t.format 'create-a-new-team'
    @

  clickTeam: (e) ->
    @$('.js-team').addClass('disabled')
    idOrg = @$(e.currentTarget).attr('data-idOrganization')
    @$(e.currentTarget).find('.js-team-logo').html(
      t.render ->
        t.span '.spinner'
    )

    @model.trigger 'added-to-team'
    track("#{@options.menuType} Menu", "Upsell Flow", "Add To Existing Team")
    Promise.fromNode (next) =>
      @model.update 'idOrganization', idOrg, { waitForServer: true }, next
    .then =>
      @$('.js-team').removeClass('disabled')
      organization = @model.getOrganization()
      if(@options.menuType == 'Collections' && organization? && organization.isFeatureEnabled('tags'))
        ModelLoader.loadOrganizationMinimal idOrg
        .then =>
          @model.trigger 'team-has-bc'
      else
        Controller.navigate Controller.getBoardPowerUpsUpgradeUrl(@model), { trigger: true }
    .done()

  clickCreateTeam: (e) ->
    @createNewTeam = true
    @render()

  clickCancelNewTeam: (e) ->
    Util.stop(e)
    @model.trigger 'cancel-add-to-team'

  clickCreateNewTeam: (e) ->
    name = @$('.js-name').val()
    if !/\S/.test(name)
      return

    data =
      displayName: name

    @$('.js-create,.js-cancel')
    .prop('disabled', true)
    .addClass('disabled')

    Auth.me().organizationList.create data, {
      @modelCache
      silent: true
      success: (data) =>
        idOrg = data.id
        @model.trigger 'added-to-team'
        @model.update('idOrganization', idOrg, { waitForServer: true })

        ModelLoader.loadOrganizationMembersMinimal(idOrg)
        .then =>
          if @$('.js-add-members').prop('checked')
            org = @model.getOrganization()

            track("New Org", "Create", "#{@menuType} Sidebar (with members)", data.id)

            Promise.map @model.memberList.models, (member) =>
              if !org.isMember(member)
                org.changeMemberRole(member, { type: 'normal' })
            , { concurrency: 3 }
          else
            track("New Org", "Create", "#{@menuType} Sidebar (without members)", data.id)
        .then =>
          Controller.navigate Controller.getBoardPowerUpsUpgradeUrl(@model), { trigger: true }
        .done()
    }
